import React from 'react'
import { CustomButton } from './button'

interface ScrollButtonProps {
  className?: string
  ariaLabel: string
  targetId: string
  offset?: number
}
export const ScrollButton: React.FC<ScrollButtonProps> = ({
  targetId,
  ariaLabel,
  offset = 0,
  ...props
}) => (
  <CustomButton
    {...props}
    aria-label={ariaLabel}
    onClick={() => {
      const element = document.getElementById(targetId)
      if (element !== null) {
        window.scrollTo({
          top: (element && element.getBoundingClientRect().top + offset) || 0,
          behavior: 'smooth',
        })
      }
    }}
  />
)
